import React from 'react';
import { Typography, Space } from 'antd';
import { HeaderContainer, BodyContainer } from '../../../../base-react/components/Container';
import { useParams } from 'react-router-dom';
import { _T } from '../../../../base-react/src/Localization';
import { JudgeCompetitionList } from './components/JudgeCompetitionList';
import { ClassPanelAssignments } from './components/ClassPanelAssignments';
import { JudgingPanelsOverview } from './components/JudgingPanelsOverview';
import { JudgeTypeLegend } from './components/JudgeTypeLegend';
import { useCompetition } from '../../../../base-react/hooks/Competition';
const { Title } = Typography;
export const Judges = () => {
    const { event_id, competition_id } = useParams();
    const [, , , , , canEdit] = useCompetition(competition_id);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('judges.plural')))),
        React.createElement(BodyContainer, null,
            React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%' } },
                React.createElement(JudgeCompetitionList, { event_id: event_id, competition_id: competition_id, disabled: !canEdit }),
                React.createElement(JudgeTypeLegend, null),
                React.createElement(JudgingPanelsOverview, { event_id: event_id, competition_id: competition_id, disabled: !canEdit }),
                React.createElement(ClassPanelAssignments, { competition_id: competition_id, disabled: !canEdit })))));
};
